export default {
  brand: 'AllChinaBuy Spreadsheet',
  nav: {
    home: 'Home',
    categories: 'Categories',
    guide: 'Spreadsheet Guide',
    guides: 'Guides',
    about: 'About',
    sheet: 'AllChinaBuy Sheet',
    faq: 'FAQ',
    collapse: 'Collapse',
    expand: 'Expand',
  },
  lang: {
    label: 'Language',
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  cta: {
    spreadsheet: 'AllChinaBuy Spreadsheet',
    buyNow: 'Buy It Now',
    explore: 'Explore the Spreadsheet',
    browse: 'Browse Categories',
    readGuide: 'Read the Guide',
    backHome: 'Back to Home',
    allCategories: 'All Categories',
  },
  disclosure:
    'This website is an independent information resource and is not affiliated with or endorsed by AllChinaBuy. We may earn a commission from qualifying purchases made through links on this site.',
  footer: {
    tagline:
      'Your independent guide to finding products, checking quality and shopping smarter with the AllChinaBuy spreadsheet.',
    quickLinks: 'Quick Links',
    categoriesTitle: 'Categories',
    resources: 'Resources',
    guide: 'Spreadsheet Guide',
    safety: 'Safety & Disclosure',
    copyright: '© 2026 AllChinaBuy Spreadsheet. All rights reserved.',
    madeWith: 'Made for smarter shopping.',
  },
};